/**
 * Parse an RFC 4180-style comma-delimited document.
 *
 * The parser deliberately does not trim values: passwords and display names
 * must reach validation exactly as they appeared in the source document.
 */
export function parseCsv(text) {
  const source = String(text || "").replace(/^\uFEFF/, "");
  const rows = [];
  const errors = [];
  let row = [];
  let field = "";
  let inQuotes = false;
  let quotedField = false;
  let justClosedQuote = false;
  let line = 1;
  let rowStartLine = 1;

  const pushField = () => {
    row.push(field);
    field = "";
    quotedField = false;
    justClosedQuote = false;
  };

  const pushRow = () => {
    pushField();
    rows.push({ line: rowStartLine, values: row });
    row = [];
    rowStartLine = line;
  };

  for (let index = 0; index < source.length; index += 1) {
    const char = source[index];

    if (inQuotes) {
      if (char === '"') {
        if (source[index + 1] === '"') {
          field += '"';
          index += 1;
        } else {
          inQuotes = false;
          justClosedQuote = true;
        }
      } else {
        field += char;
        if (char === "\n" || (char === "\r" && source[index + 1] !== "\n")) {
          line += 1;
        }
      }
      continue;
    }

    if (justClosedQuote && char !== "," && char !== "\r" && char !== "\n") {
      errors.push({
        line,
        code: "unexpected_character_after_quote",
        message: "Unexpected character after a closing quote.",
      });
      justClosedQuote = false;
    }

    if (char === '"') {
      if (field.length === 0 && !quotedField) {
        inQuotes = true;
        quotedField = true;
      } else {
        errors.push({
          line,
          code: "unescaped_quote",
          message:
            "A quote inside an unquoted field must be escaped by quoting the entire field.",
        });
        field += char;
      }
      continue;
    }

    if (char === ",") {
      pushField();
      continue;
    }

    if (char === "\r" || char === "\n") {
      if (char === "\r" && source[index + 1] === "\n") index += 1;
      line += 1;
      pushRow();
      rowStartLine = line;
      continue;
    }

    field += char;
  }

  if (inQuotes) {
    errors.push({
      line: rowStartLine,
      code: "unterminated_quote",
      message: "Unterminated quoted field.",
    });
  }

  if (field.length > 0 || row.length > 0 || quotedField || justClosedQuote) {
    pushRow();
  }

  return { rows, errors };
}

export function isBlankCsvRow(row) {
  return row.values.every((value) => String(value).trim() === "");
}
